export const money = (n) => (n == null ? "—" : `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

export async function downloadExport(api, path, params, filenameBase, fmt) {
  const res = await api.get(`${path}/export/${fmt}`, { params, responseType: "blob" });
  const disposition = res.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename=([^;]+)/);
  const filename = match ? match[1].trim() : `${filenameBase}_${new Date().toISOString().slice(0, 10)}.${fmt}`;
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function buildParams(filters) {
  const params = {};
  Object.entries(filters).forEach(([k, v]) => { if (v && v !== "all") params[k] = v; });
  return params;
}
